import { resolveImageUrl } from "@/lib/api";

export default function Hero() {
  return (
    <section id="top" className="relative w-full h-[720px] md:h-[820px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={resolveImageUrl("/uploads/home-hero.jpg")}
          alt="한국의 산림 파쇄 전문 우공이산 헤로 배경 이미지"
          className="w-full h-full object-cover object-top animate-slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/40 to-foreground-950/70"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col">
        <div className="flex-1 flex items-center">
          <div className="w-full max-w-6xl mx-auto px-6 md:px-10 text-center animate-fade-up">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/10 backdrop-blur border border-background-50/30 mb-8">
              <span className="w-2 h-2 rounded-full bg-accent-400"></span>
              <span className="text-background-50 text-xs tracking-[0.25em] uppercase font-medium">
                Wood Chipping · Grinding · Recycling
              </span>
            </div>

            <h1 className="font-heading font-bold text-background-50 text-4xl md:text-6xl lg:text-7xl leading-[1.15] tracking-tight">
              오랜 시간이 걸려도,
              <br />
              <span className="text-accent-300">우공이 산을 옮기듯</span>
            </h1>

            <p className="mt-8 max-w-2xl mx-auto text-base md:text-lg text-background-100 leading-relaxed">
              독일 JENZ HEM 820DL 대형 칩핑기로 원목칩·가지칩·뿌리 파쇄까지,
              <br className="hidden md:block" />
              흔들림 없는 품질과 신뢰로 대한민국 산림 자원의 순환을 만듭니다.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="#equipment"
                className="px-8 py-4 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium text-sm tracking-wide transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                장비 살펴보기
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="/inquiries"
                className="px-8 py-4 rounded-md bg-background-50/10 backdrop-blur border border-background-50/40 hover:bg-background-50/20 text-background-50 font-medium text-sm tracking-wide transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                파쇄 상담 신청
              </a>
            </div>
          </div>
        </div>

        <div className="pb-10 md:pb-14">
          <div className="w-full max-w-6xl mx-auto px-6 md:px-10">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {[
                { k: "800mm", l: "최대 투입 지름" },
                { k: "644 PS", l: "엔진 출력" },
                { k: "12(24)", l: "장착 칼날 수" },
                { k: "4종", l: "보유 스크린" },
              ].map((s, i) => (
                <div
                  key={i}
                  className="bg-background-50/10 backdrop-blur-md border border-background-50/20 rounded-lg px-4 py-4 md:px-5 md:py-5 text-center hover:bg-background-50/20 hover:border-background-50/40 hover:scale-105 hover:-translate-y-1 hover:shadow-lg hover:shadow-background-950/20 transition-all duration-300 cursor-pointer"
                  style={{ animation: `fadeUp 0.7s ease-out ${0.2 + i * 0.12}s both` }}
                >
                  <div className="font-heading text-background-50 text-2xl md:text-3xl font-bold">
                    {s.k}
                  </div>
                  <div className="text-background-100/80 text-xs md:text-sm mt-1 tracking-wide">
                    {s.l}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}